<template>

  <a href="javascript:void(0);" id="btnMenu" class="pull-end p-3"
     @click="alternarMenu(!this.mostrarMenu)">
    <div class="row">
      <div class="col-md-4">
        <span class="bar-icon">
            <span></span>
            <span></span>
            <span></span>
        </span>
      </div>
      <div class="col-md-4 text-menu">
        <div class="me-4">{{ $t('menu.menu') }}</div>
      </div>
    </div>
  </a>

  <div :class="['floating-menu', ...[getMenuTheme], ...(mostrarMenu ? [] : ['visually-hidden'])]" id="floatingMenu">

    <div class="floating-menu-header">
      <div class="img-fluid bg-logo" style="width: 182px; height: 46px; "/>
      <a id="menu_close" class="menu-close pull-end" href="javascript:void(0);"
         @click="alternarMenu(false)">
        <i class="fas fa-times"></i>
      </a>
    </div>

    <div :class="'main-menu ' + getMenuTheme">
      <div class="accordion" id="accordionExample">

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button :class="['accordion-button', perfilSectionActive ? '' : 'collapsed', { 'section-active': perfilSectionActive }]"
                    type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse_login"
                    aria-expanded="false" aria-controls="collapse_login">
              <li class="nav-item user-nav">

                <span class="user-img">
                  <img v-if="usuario && usuario.Foto" :src="usuario.Foto" alt=""/>
                  <img v-else-if="getTheme == 'uca'" src="../assets/img/uca/avatar-icon.png" alt=""/>
                  <img v-else-if="getTheme == 'esn'" src="../assets/img/esn/avatar-icon.png" alt=""/>
                  <span class="status online"></span>
                </span>
                <div class="user-header float-end px-0">
                  <div class="user-text" v-if="usuario" style="width: 132px">
                    <h6 class="m-0">{{ usuario.Nome }} </h6>
                    <p class="text-muted mb-0 text-xs" v-if="usuario.Admin">{{ $t('menu.administrator') }}</p>
                  </div>
                </div>
              </li>
              <li class="nav-item noti-nav" v-if="temPermissaoMensagem">

                <div class="user-text">
                  <i class="feather-bell fw-bold" style="color: #FF5364 " v-if="temNova"
                     :title="$t('menu.newMessagesNotifications')"></i>
                  <i class="feather-bell fw-bold" v-else :title="$t('menu.noMessagesNotifications')"></i>
                </div>
              </li>
            </button>
          </h2>
          <div class="accordion-collapse collapse"
               :class="{ show: perfilSectionActive }"
               id="collapse_login"
               aria-labelledby="headingOne"
               data-bs-parent="#accordionExample">
            <div class="accordion-body">

              <ul class="submenu" style="display: block !important">

                <li class="has-submenu submenu-perfil" :class="{ active: isMenuRouteActive('/perfil') }">
                  <a class="dropdown-item cursor-pointer submenu-perfil-link" @click="this.$router.push('/perfil')">
                    <div class="submenu-perfil-wrap">
                      <i class="feather-user submenu-perfil-icon"/>
                      <div class="submenu-perfil-detail">
                        
                        <template v-if="usuario && !usuario.Admin">
                          <span >{{ $t('menu.profile') }}: {{ usuario.Nome }}</span>
                          <p class="submenu-perfil-email text-muted mb-0 text-xs">{{ usuario.Email }}</p>
                        </template>
                      </div>
                    </div>
                  </a>
                </li>
                <li class="has-submenu" :class="{ active: isMenuRouteActive('/perfil/alterar-senha') }">
                  <a class="dropdown-item cursor-pointer" @click="this.$router.push('/perfil/alterar-senha')">
                    <i class="feather-lock me-1"></i> {{ $t('menu.changePassword') }}
                  </a>
                </li>
                <li class="has-submenu">
                  <a class="dropdown-item cursor-pointer" @click="toggleDarkMode">
                    <span v-if="darkModeEnabled"><i class="feather-sun me-1"/> {{ $t('menu.lightMode') }}</span>
                    <span v-else><i class="feather-moon me-1"/> {{ $t('menu.darkMode') }}</span>
                  </a>
                </li>
                <li class="has-submenu">
                  <a class="dropdown-item cursor-pointer" @click="logout">
                    <i class="feather-log-out me-1"></i> {{ $t('menu.logout') }}
                  </a>
                </li>
              </ul>

            </div>
          </div>
        </div>

        <ul v-if="temPermissaoMensagem" class="submenu menu-mensagens-fixo">
          <li class="has-submenu" v-if="Mensagens > 0" :class="{ active: isMenuRouteActive('/aluno/mensagens') || isMenuRouteActive('/academico/mensagens') }">
            <a class="dropdown-item cursor-pointer" @click="irParaMensagens('email')">
              <div class="edu-wrap">
                <div class="edu-name">
                  <span>{{ Mensagens }}</span>
                </div>
                <div class="edu-detail">
                  <h6 class="text-white">{{ $t('menu.unreadMessages') }}</h6>
                  <p class="text-xs mb-1">{{ $t('menu.goToMessages') }} <i class="fa-solid feather-chevron-right"/></p>
                </div>
              </div>
            </a>
          </li>
          <li class="has-submenu" v-if="Notificacoes > 0" :class="{ active: isMenuRouteActive('/aluno/mensagens/notificacao') || isMenuRouteActive('/academico/mensagens/notificacao') }">
            <a class="dropdown-item cursor-pointer" @click="irParaMensagens('notificacao')">
              <div class="edu-wrap">
                <div class="edu-name">
                  <span>{{ Notificacoes }}</span>
                </div>
                <div class="edu-detail">
                  <h6 class="text-white">{{ $t('menu.unreadNotifications') }}</h6>
                  <p class="text-xs mb-1">{{ $t('menu.goToNotifications') }} <i class="fa-solid feather-chevron-right"/></p>
                </div>
              </div>
            </a>
          </li>
        </ul>

        <div class="accordion-item" v-for="(menu, m_index) in Menu" :key="m_index">
          <h2 class="accordion-header" id="headingOne">
            <button :class="['accordion-button', menuAccordionExpandido(menu) ? '' : 'collapsed', { 'section-active': menuSectionActive(menu) }]" type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#collapse_${m_index}`"
                    :aria-expanded="menuAccordionExpandido(menu) ? 'true' : 'false'" :aria-controls="`collapse_${m_index}`">
              <i :class="menu.icon" v-if="menu.icon"/> {{ menu.Name }}
            </button>
          </h2>
          <div :id="`collapse_${m_index}`" :class="['accordion-collapse', 'collapse', { show: menuAccordionExpandido(menu) }]"
               aria-labelledby="headingOne"
               data-bs-parent="#accordionExample">
            <div class="accordion-body">

              <ul class="submenu" style="display: block !important" :id="'submenuInnerAccordion_' + m_index">
                <li v-for="(submenu, sm_index) in menu.Submenu" :key="sm_index"
                    :class="{
                      active: menuItemActive(submenu),
                      'has-submenu': !!submenu.Submenu,
                      'has-submenu-collapse': submenu.collapseAccordion && submenu.Submenu
                    }">

                  <a :href="submenu.to" v-if="submenu?.target == 'new'" target="_new">
                    <i :class="submenu.icon" v-if="submenu.icon"/> {{ submenu.Name }}
                  </a>

                  <router-link :to="submenu.to" v-if="!submenu?.target && submenu.to" active-class="" :class="{ active: menuItemActive(submenu) }">
                    <i :class="submenu.icon" v-if="submenu.icon"/> {{ submenu.Name }}
                  </router-link>

                  <a href="javascript:void(0);" v-if="submenu.action === 'videoCall'" @click="modalVideoChamada">
                    <i :class="submenu.icon" v-if="submenu.icon"/> {{ submenu.Name }}
                  </a>

                  <a href="javascript:void(0);"
                     v-if="submenu.collapseAccordion && submenu.Submenu"
                     :class="['submenu-collapse-toggle', menuItemActive(submenu) ? '' : 'collapsed']"
                     role="button"
                     data-bs-toggle="collapse"
                     :data-bs-target="'#submenuCollapse_' + m_index + '_' + sm_index"
                     :aria-expanded="menuItemActive(submenu) ? 'true' : 'false'"
                     :aria-controls="'submenuCollapse_' + m_index + '_' + sm_index">
                    <i :class="submenu.icon" v-if="submenu.icon"/> {{ submenu.Name }}
                  </a>
                  <div v-if="submenu.collapseAccordion && submenu.Submenu"
                       :id="'submenuCollapse_' + m_index + '_' + sm_index"
                       :class="['collapse', { show: menuItemActive(submenu) }]"
                       :data-bs-parent="'#submenuInnerAccordion_' + m_index">
                    <ul class="submenu">
                      <li v-for="(submenu1, sm1_index) in submenu.Submenu" :key="sm1_index" :class="{ active: menuItemActive(submenu1) }">
                        <a :href="submenu1.to" v-if="submenu1?.target == 'new' && submenu1.to" target="_blank" rel="noopener noreferrer">
                          <i :class="submenu1.icon" v-if="submenu1.icon"/> {{ submenu1.Name }}
                        </a>
                        <router-link :to="submenu1.to" v-else-if="submenu1.to" active-class="" :class="{ active: menuItemActive(submenu1) }">
                          <i :class="submenu1.icon" v-if="submenu1.icon"/> {{ submenu1.Name }}
                        </router-link>
                        <a href="javascript:void(0);" v-else-if="submenu1.action === 'videoCall'" @click="modalVideoChamada">
                          <i :class="submenu1.icon" v-if="submenu1.icon"/> {{ submenu1.Name }}
                        </a>
                      </li>
                    </ul>
                  </div>

                  <a href="javascript:void(0);" v-if="submenu.Submenu && !submenu.to && !submenu?.target && !submenu.collapseAccordion"
                     :class="{ active: menuItemActive(submenu) }">
                    <i :class="submenu.icon" v-if="submenu.icon"/> {{ submenu.Name }}
                  </a>

                  <a href="javascript:void(0);" v-if="!submenu?.to && !submenu?.Submenu && !submenu?.action" class="disabled">{{ submenu.Name }}</a>
                  <ul class="submenu" v-if="submenu.Submenu && !submenu.collapseAccordion">
                    <li v-for="(submenu1, sm1_index) in submenu.Submenu" :key="sm1_index" :class="{ active: menuItemActive(submenu1) }">
                      <a :href="submenu1.to" v-if="submenu1?.target == 'new' && submenu1.to" target="_blank" rel="noopener noreferrer">
                        <i :class="submenu1.icon" v-if="submenu1.icon"/> {{ submenu1.Name }}
                      </a>
                      <router-link :to="submenu1.to" v-else-if="submenu1.to" active-class="" :class="{ active: menuItemActive(submenu1) }">
                        <i :class="submenu1.icon" v-if="submenu1.icon"/> {{ submenu1.Name }}
                      </router-link>
                      <a href="javascript:void(0);" v-else-if="submenu1.action === 'videoCall'" @click="modalVideoChamada">
                        <i :class="submenu1.icon" v-if="submenu1.icon"/> {{ submenu1.Name }}
                      </a>
                    </li>
                  </ul>
                </li>

              </ul>

            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>
<script>
import salaDeAulaService from "../Services/SalaDeAula.service";
import modoAlunoService from "../Services/ModoAluno.service";
import userService from "../helpers/user.service";
import authService from "../Services/Auth.service";
import Helper from "../helpers/helper.service";
import MenuLogin from "../mixins/menu.login.mix";
import eventBus from '../helpers/event.bus';
import {Capacitor} from '@capacitor/core';


export default {
  mixins: [MenuLogin],
  computed: {
    getTheme() {
      return Helper.getTheme()
    },
    getMenuTheme() {
      return `menu_${Helper.getTheme()}`
    },
    temPermissaoMensagem() {
      return userService.checkPermision('Mensagem')
    },
    menuAccordionAbertoPorDefeito() {
      if (this.usuario?.TipoUsuario === 'aluno' || this.checkModoAluno())
        return this.$t('menu.menu')
      return this.$t('menu.academic')
    },
    rotaAtualNormalizada() {
      const path = this.$route.path
      if (path.length > 1 && path.endsWith('/'))
        return path.slice(0, -1)
      return path
    },
    temSecaoMenuAtiva() {
      return this.Menu.some(menu => this.menuSectionActive(menu))
    },
    perfilSectionActive() {
      return this.isMenuRouteActive('/perfil') || this.isMenuRouteActive('/perfil/alterar-senha')
    },
    Menu_completo_traduzido() {
      const usuario = userService.getUser()

      return this.aplicarShowInMobilePadrao([
      {
        Name: this.$t('menu.contactGroup'),
        icon: null,
        Modo: 'aluno',
        showInMobile: true,
        contactMenu: true,
        Submenu: [
          {
            Name: (usuario.TipoUsuario == 'administrativo') ? this.$t('menu.inbox') : this.$t('menu.contactTutor'),
            icon: 'fa-regular fa-envelope',
            Controller: 'Mensagem',
            to: '/aluno/mensagens',
            active: false
          },
          {
            Name: this.$t('menu.contactTutor'),
            icon: 'fa-brands fa-whatsapp',
            Controller: 'FaleComTutor',
            target: 'new',
            to: (Helper.getTheme() == 'uca') ? Helper.getUCAWhatsappLink() : Helper.getESNWhatsappLink(),
            active: false
          },
          {
            Name: this.$t('menu.videoCall'),
            icon: 'fa-solid fa-phone',
            action: 'videoCall',
            active: false
          }
        ]
      },
      {
        Name: this.$t('menu.menu'),
        icon: null,
        Modo: 'aluno',
        showInMobile: true,
        Submenu: [
          {
            Name: this.$t('menu.disciplines'),
            icon: null,
            Controller: 'SalaDeAula',
            to: '/aluno/sala-de-aula/disciplina/atuais',
            matchPrefix: '/aluno/sala-de-aula',
            active: false,
            Submenu: [
              {
                Name: this.$t('menu.currentDisciplines'),
                icon: null,
                Controller: 'SalaDeAula',
                to: '/aluno/sala-de-aula/disciplina/atuais',
                active: false,
              },
              {
                Name: this.$t('menu.previousDisciplines'),
                icon: null,
                Controller: 'SalaDeAula',
                to: '/aluno/sala-de-aula/disciplina/anteriores',
                active: false,
              },
            ]
          },
          {
            Name: this.$t('menu.myGrades'),
            icon: 'fa-solid fa-graduation-cap',
            Controller: 'AlunoNotas',
            to: '/aluno/notas',
            active: false
          },
          {
            Name: this.$t('menu.courses'),
            icon: 'fa-solid fa-book-open',
            Controller: 'AlunoNotas',
            to: '/aluno/cursos',
            active: false
          },
          {
            Name: this.$t('menu.boletim'),
            icon: 'fa-solid fa-file-lines',
            Controller: 'AlunoNotas',
            to: '/aluno/boletim',
            active: false
          },
          {
            Name: this.$t('menu.atividadesComplementares'),
            icon: 'fa-solid fa-clock',
            Controller: 'AlunoNotas',
            to: '/aluno/atividades-complementares',
            active: false
          },
          {
            Name: this.$t('menu.carreirasEstagios'),
            icon: 'fa-solid fa-briefcase',
            target: 'new',
            Controller: 'AlunoNotas',
            to: 'https://portal.uca.edu.br/logincandidato.aspx',
            active: false
          },
          {
            Name: this.$t('menu.adapt'),
            icon: 'fa-solid fa-shuffle',
            Controller: 'AlunoNotas',
            to: '/aluno/adapt',
            active: false
          },
          {
            Name: this.$t('menu.sub'),
            icon: 'fa-solid fa-repeat',
            Controller: 'AlunoNotas',
            to: '/aluno/sub',
            active: false
          },
          {
            Name: this.$t('menu.financeiro'),
            icon: 'fa-solid fa-hand-holding-dollar',
            Controller: 'DocumentoAluno',
            to: '/aluno/financeiro',
            active: false
          },
          {
            Name: this.$t('menu.renegociacao'),
            icon: 'fa-solid fa-handshake',
            Controller: 'DocumentoAluno',
            to: '/aluno/renegociacao',
            active: false
          },
          {
            Name: this.$t('menu.documents'),
            icon: 'fa-solid fa-folder',
            Controller: 'DocumentoAluno',
            to: '/aluno/documentos/meus-documentos',
            active: false
          },
          {
            Name: this.$t('menu.solicitacoes'),
            icon: 'fa-solid fa-headset',
            Controller: 'DocumentoAluno',
            to: '/aluno/solicitacoes',
            active: false
          }
        ]
      },
      {
        Name: this.$t('menu.academic'),
        icon: null,
        Modo: 'admin',
        showInMobile: false,
        Submenu: [
          {
            Name: this.$t('menu.courses'),
            icon: null,
            Controller: 'Curso',
            to: '/academico/curso',
            active: false
          },
          {
            Name: this.$t('menu.academicPeriod'),
            icon: null,
            Controller: 'PeriodoLetivo',
            to: '/academico/periodo-letivo',
            active: false
          },
          {
            Name: this.$t('menu.disciplines'),
            icon: null,
            Controller: 'Disciplina',
            to: '/academico/disciplina',
            active: false
          },
          {
            Name: this.$t('menu.questionBank'),
            icon: null,
            Controller: 'BancoPergunta',
            to: '/academico/bancoperguntas',
            active: false
          },
          {
            Name: this.$t('menu.classes'),
            icon: null,
            Controller: 'Turma',
            to: '/academico/turma',
            active: false
          },
          {
            Name: this.$t('menu.grades'),
            icon: null,
            Controller: 'Notas',
            to: '/academico/notas',
            active: false
          },
        ]
      },
      {
        Name: this.$t('menu.administrative'),
        icon: null,
        Modo: 'admin',
        showInMobile: false,
        Submenu: [
          {
            Name: 'Franqueados',
            icon: null,
            Controller: 'Franqueado',
            to: '/administrativo/franqueado',
            active: false
          },
          {
            Name: this.$t('menu.administrativeUsers'),
            icon: null,
            Controller: 'UsuarioAdministrativo',
            to: '/administrativo/usuario',
            active: false
          },
          {
            Name: this.$t('menu.studentUsers'),
            icon: null,
            Controller: 'Usuario',
            to: '/administrativo/aluno',
            active: false
          },
          {
            Name: this.$t('menu.profilePermissions'),
            icon: null,
            Controller: 'PerfilPermissoes',
            to: '/administrativo/perfil',
            active: false
          },
          {
            Name: this.$t('menu.disciplineTeacher'),
            icon: null,
            Controller: 'InstrutorDisciplina',
            to: '/administrativo/instrutor',
            active: false
          },
          {
            Name: this.$t('menu.activitiesInProgress'),
            icon: null,
            Controller: 'AtividadesEmAndamento',
            to: '/administrativo/atividades-em-andamento',
            active: false
          },
          {
            Name: this.$t('menu.activitySubmissions'),
            icon: null,
            Controller: 'EntregasDeAtividades',
            to: '/administrativo/entregas-atividade',
            active: false
          },
          {
            Name: this.$t('menu.reports'),
            Controller: 'Relatorios',
            Submenu: [
              {
                Name: this.$t('menu.classReport'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/aulas',
                active: false
              },
              {
                Name: this.$t('menu.activityReport'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/atividades',
                active: false
              },
              {
                Name: this.$t('menu.activityCorrectionReport'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/correcaoatividades',
                active: false
              },
              {
                Name: this.$t('menu.studentsInExamReport'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/alunosexame',
                active: false
              },
              {
                Name: this.$t('menu.disciplineSummaryReport'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/resumodisciplina',
                active: false
              },
              {
                Name: this.$t('menu.studentPerformance'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/desempenho-aluno',
                active: false
              },
              {
                Name: this.$t('menu.detailedStudent'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/detalhado-aluno',
                active: false
              },
              {
                Name: this.$t('menu.studentStatusComparison'),
                icon: null,
                Controller: 'Relatorios',
                to: '/administrativo/relatorios/confronto-situacao-aluno',
                active: false
              },
            ]
          }
        ]
      },
      {
        Name: this.$t('menu.configuration'),
        icon: null,
        Modo: 'admin',
        showInMobile: false,
        Submenu: [
          {
            Name: this.$t('menu.systemLog'),
            icon: null,
            Controller: 'Log',
            to: '/configuracao/log',
            active: false
          },
          {
            Name: this.$t('menu.messageLog'),
            icon: null,
            Controller: 'Log',
            to: '/configuracao/logmensagem',
            active: false
          }
        ]
      }
    ])
    }
  },
  data() {

    return {
      darkModeEnabled: false,
      Menu: [],
      mostrarMenu: false,
      usuario: userService.getUser(),
      unsubscribeUserUpdated: null,
      Mensagens: 0,
      Notificacoes: 0,
      temNova: false
    }
  },
  beforeMount() {
    this.$router.beforeEach(async (to, from, next) => {

      if (!window.rotasSemAuth.includes(to.path) && userService.isAuthenticated()) {
        await authService.refreshTokenIfNeeded(12)
        this.montaMenu()
      }

      next();
    })

    this.$router.afterEach((to) => {

      this.alternarMenu(false)

      if (!window.rotasSemAuth.includes(to.path) && userService.isAuthenticated()) {
        this.montaMenu()
      }

    })

  },
  mounted() {

    eventBus.addEventListener('MensagensNotificacao', this.receberMensagensNotificacao);

    this.unsubscribeUserUpdated = userService.onUserUpdated(() => {
      this.usuario = userService.getUser();
    });

    this.montaMenu();

    window.addEventListener('resize', this.checkResolution);

    this.checkResolution();

  },
  beforeUnmount() {
    if (this.unsubscribeUserUpdated)
      this.unsubscribeUserUpdated();
    eventBus.removeEventListener('MensagensNotificacao', this.receberMensagensNotificacao);
  },
  methods: {
    irParaMensagens(tipo) {
      const destino = userService.getRotaMensagens(tipo === 'notificacao' ? 'notificacao' : null)
      this.$router.push(destino)
    },
    checkModoAluno() {
      return modoAlunoService.checkModoAluno()
    },
    receberMensagensNotificacao(event) {

      this.Mensagens = event.detail?.mensagens ?? 0;
      this.Notificacoes = event.detail?.notificacoes ?? 0;

      if (this.Mensagens > 0 || this.Notificacoes > 0) {
        this.temNova = true;
      } else {
        this.temNova = false;
      }

    },
    modalVideoChamada() {
      document.getElementById("btnModalVideoChamada").click();

    },
    checkResolution() {

      const width = window.innerWidth;
      const height = window.innerHeight;

      const self = this;

      var clickMenu = function (event) {

        const menu = document.getElementById('floatingMenu');
        const btnMenu = document.getElementById('btnMenu');

        if (menu && !menu.contains(event.target) && !btnMenu.contains(event.target)) {
          self.alternarMenu(false)
        }

      };

      if (width >= 1920) {
        this.mostrarMenu = true
        window.removeEventListener('click', clickMenu);

      } else {
        this.mostrarMenu = false
        window.addEventListener('click', clickMenu);

      }

    },
    alternarMenu(valor) {
      if (window.innerWidth < 1920)
        this.mostrarMenu = valor;
    },
    normalizarRota(path) {
      if (!path)
        return ''
      if (path.length > 1 && path.endsWith('/'))
        return path.slice(0, -1)
      return path
    },
    isMenuRouteActive(to, item = null) {
      if (!to || /^https?:\/\//i.test(to))
        return false

      const current = this.rotaAtualNormalizada
      const target = this.normalizarRota(to)

      if (item?.matchPrefix) {
        const prefix = this.normalizarRota(item.matchPrefix)
        if (current === prefix || current.startsWith(`${prefix}/`))
          return true
      }

      if (current === target || current.startsWith(`${target}/`))
        return true

      return false
    },
    menuItemActive(item) {
      if (!item)
        return false

      const activeChildren = item.Submenu?.filter(child => this.menuItemActive(child)) ?? []

      if (item.to) {
        if (activeChildren.length > 0 && item.matchPrefix)
          return false

        if (this.isMenuRouteActive(item.to, item))
          return true
      }

      return activeChildren.length > 0
    },
    menuSectionActive(menu) {
      return menu?.Submenu?.some(item => this.menuItemActive(item)) ?? false
    },
    menuAccordionExpandido(menu) {
      if (this.menuSectionActive(menu))
        return true
      if (this.temSecaoMenuAtiva)
        return false
      return menu.Name === this.menuAccordionAbertoPorDefeito
    },
    filtrarSubmenuContato(submenu, permissoes) {
      return submenu.filter(child => {
        if (child.action === 'videoCall')
          return this.usuario?.TipoUsuario === 'aluno' || this.checkModoAluno()
        return child.Controller && permissoes.some(i => i.Controller === child.Controller)
      })
    },
    isPlataformaMobileNativa() {
      const plataforma = Capacitor.getPlatform()
      return plataforma === 'android' || plataforma === 'ios'
    },
    itemVisivelNoMobile(item, herdarSecao = false) {
      if (item?.showInMobile === false)
        return false
      if (item?.showInMobile === true)
        return true
      return herdarSecao
    },
    aplicarShowInMobilePadraoItem(item) {
      const normalizado = { ...item }
      if (item?.showInMobile !== undefined)
        normalizado.showInMobile = item.showInMobile
      if (item?.Submenu)
        normalizado.Submenu = item.Submenu.map(sub => this.aplicarShowInMobilePadraoItem(sub))
      return normalizado
    },
    aplicarShowInMobilePadrao(menus) {
      return menus.map(menu => ({
        ...menu,
        showInMobile: menu?.showInMobile ?? false,
        Submenu: menu.Submenu?.map(item => this.aplicarShowInMobilePadraoItem(item))
      }))
    },
    filtrarSubmenuMobile(submenu, secaoVisivelMobile = false) {
      if (!submenu)
        return []

      return submenu
        .filter(item => this.itemVisivelNoMobile(item, secaoVisivelMobile))
        .map(item => {
          const itemVisivelMobile = this.itemVisivelNoMobile(item, secaoVisivelMobile)
          if (!item.Submenu)
            return item
          const sub = this.filtrarSubmenuMobile(item.Submenu, itemVisivelMobile || secaoVisivelMobile)
          if (sub.length === 0 && !item.to && !item.action && !item?.target)
            return null
          if (sub.length === 0)
            return item
          return { ...item, Submenu: sub }
        })
        .filter(Boolean)
    },
    filtrarMenuPorPlataformaMobile(menus) {
      if (!this.isPlataformaMobileNativa())
        return menus

      return menus
        .filter(menu => menu?.showInMobile === true)
        .map(menu => {
          if (!menu.Submenu)
            return menu
          const sub = this.filtrarSubmenuMobile(menu.Submenu, true)
          if (sub.length === 0)
            return null
          return { ...menu, Submenu: sub }
        })
        .filter(Boolean)
    },
    getItemMensagensContactMenuUniversal() {
      const user = userService.getUser()
      const prefixo = userService.getRotaMensagensPrefixo()
      const nome = (user?.Admin || user?.TipoUsuario === 'administrativo')
        ? this.$t('menu.inbox')
        : this.$t('menu.contactTutor')

      return {
        Name: nome,
        icon: 'fa-regular fa-envelope',
        Controller: 'Mensagem',
        to: `/${prefixo}/mensagens`,
        active: false,
        showInMobile: true
      }
    },
    getSecaoContactMenuMensagensMobile() {
      const contactSection = this.Menu_completo_traduzido.find(menu => menu.contactMenu)
      if (!contactSection)
        return null

      return {
        Name: contactSection.Name,
        showInMobile: true,
        contactMenu: true,
        Submenu: [{ ...this.getItemMensagensContactMenuUniversal() }]
      }
    },
    aplicarContactMenuMensagensMobile(filteredMenu) {
      if (!this.isPlataformaMobileNativa())
        return filteredMenu

      const secao = this.getSecaoContactMenuMensagensMobile()
      if (!secao)
        return filteredMenu

      const contactName = secao.Name
      const itemMensagens = secao.Submenu[0]
      const existingContact = filteredMenu.find(menu => menu.Name === contactName)

      if (existingContact) {
        existingContact.showInMobile = true
        const indiceMensagens = existingContact.Submenu.findIndex(item => item.Controller === 'Mensagem')
        if (indiceMensagens >= 0)
          existingContact.Submenu[indiceMensagens] = { ...existingContact.Submenu[indiceMensagens], ...itemMensagens }
        else
          existingContact.Submenu.unshift({ ...itemMensagens })
        return filteredMenu
      }

      return [secao, ...filteredMenu]
    },
    isItemMenuDisciplinasUniversal(item) {
      return item?.Controller === 'SalaDeAula' && Array.isArray(item?.Submenu) && item.Submenu.length > 0
    },
    clonarItemMenuDisciplinasUniversal(item) {
      return {
        ...item,
        Submenu: item.Submenu.map(sub => ({ ...sub }))
      }
    },
    getSecaoMenuDisciplinasUniversal() {
      const menuSection = this.Menu_completo_traduzido.find(menu =>
        !menu.contactMenu && menu.Modo === 'aluno' && menu.Name === this.$t('menu.menu')
      )
      const disciplinas = menuSection?.Submenu?.find(item => this.isItemMenuDisciplinasUniversal(item))
      if (!disciplinas)
        return null

      return {
        Name: this.$t('menu.menu'),
        showInMobile: menuSection?.showInMobile ?? false,
        Submenu: [this.clonarItemMenuDisciplinasUniversal(disciplinas)]
      }
    },
    aplicarMenuDisciplinasUniversal(filteredMenu) {
      const secao = this.getSecaoMenuDisciplinasUniversal()
      if (!secao)
        return filteredMenu

      const menuName = this.$t('menu.menu')
      const existingMenu = filteredMenu.find(menu => menu.Name === menuName)

      if (existingMenu) {
        if (!existingMenu.Submenu.some(item => this.isItemMenuDisciplinasUniversal(item))) {
          existingMenu.Submenu.unshift(this.clonarItemMenuDisciplinasUniversal(secao.Submenu[0]))
        }
        return filteredMenu
      }

      const result = [...filteredMenu]
      const indiceMenuAdmin = result.findIndex(menu => menu.Name === this.$t('menu.academic'))
      if (indiceMenuAdmin >= 0)
        result.splice(indiceMenuAdmin, 0, secao)
      else
        result.unshift(secao)

      return result
    },
    filtrarItemSubmenuAluno(item, permissoes) {
      if (this.isItemMenuDisciplinasUniversal(item))
        return this.clonarItemMenuDisciplinasUniversal(item)
      if (!item?.Controller || !permissoes.some(i => i.Controller === item.Controller))
        return null
      return item
    },
    aplicarRotaMensagensAdministrativo(submenus) {
      submenus.forEach(sub => {
        if (sub.to === '/aluno/mensagens') {
          sub.Name = this.$t('menu.inbox')
          sub.icon = 'fa-regular fa-envelope'
          sub.Controller = 'Mensagem'
          sub.to = '/academico/mensagens'
          sub.active = false
        }
        if (sub.Submenu)
          this.aplicarRotaMensagensAdministrativo(sub.Submenu)
      })
    },
    filtraMenuModo(menu, modo) {
      menu = menu.filter(item => {
        return item.Modo == modo
      });
      return menu
    },
    montaMenu() {

      const user = userService.getUser()
      const permissoes = userService.getPermissions()

      let filteredMenu = [];

      if (!user.Admin) {

        this.Menu_completo_traduzido.forEach(menu => {
          if (menu.contactMenu) {
            const submenu = this.filtrarSubmenuContato(menu.Submenu, permissoes)
            if (submenu.length > 0)
              filteredMenu.push({ ...menu, Submenu: submenu })
          } else {
            const submenu = menu.Submenu
              .map(item => this.filtrarItemSubmenuAluno(item, permissoes))
              .filter(Boolean)

            if (submenu.length > 0)
              filteredMenu.push({ ...menu, Submenu: submenu })
          }
        })

        if (this.usuario.TipoUsuario === 'administrativo') {
          filteredMenu = filteredMenu.map(menu => {
            if (menu.Name == this.$t('menu.menu') || menu.Name == this.$t('menu.contactGroup')) {
              this.aplicarRotaMensagensAdministrativo(menu.Submenu)
            }
            return menu
          })
        }

      } else {

        if (this.checkModoAluno()) {
          filteredMenu = this.filtraMenuModo(this.Menu_completo_traduzido, 'aluno');

          filteredMenu = filteredMenu.map(i => ({
            ...i,
            Submenu: i.Submenu
              .map(j => ({
              ...j,
              Name: (j.Controller == 'Mensagem' ? this.$t('menu.contactTutor') : j.Name)
            }))
          }))

        } else {
          filteredMenu = this.filtraMenuModo(this.Menu_completo_traduzido, 'admin');
        }

        // adiciona o menu para o administrador
        filteredMenu = filteredMenu.map(menu => {
          if (menu.Name == this.$t('menu.academic')) {
            if (!menu.Submenu.find(i => i.Controller == 'Mensagem')) {
              menu.Submenu.push({
                Name: this.$t('menu.inbox'),
                icon: 'fa-regular fa-envelope',
                Controller: 'Mensagem',
                to: '/academico/mensagens',
                active: false,
                showInMobile: true
              })
            }
          }
          return menu
        })

      }

      filteredMenu = this.aplicarMenuDisciplinasUniversal(filteredMenu)
      filteredMenu = this.aplicarContactMenuMensagensMobile(filteredMenu)
      filteredMenu = this.filtrarMenuPorPlataformaMobile(filteredMenu)
      this.Menu = filteredMenu

    }
  }
}
</script>

<style scoped>
.menu-mensagens-fixo {
  display: block !important;
  margin: 0;
  padding: 0 0 0 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.submenu-perfil-link {
  padding: 12px 16px !important;
}

.submenu-perfil-wrap {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.submenu-perfil-icon {
  flex-shrink: 0;
  font-size: 1.35rem;
  margin-top: 2px;
  margin-right: 0 !important;
}

.submenu-perfil-detail {
  flex: 1;
  min-width: 0;
  line-height: 1.3;
}

.submenu-perfil-label {
  display: block;
  font-weight: 600;
}

.submenu-perfil-nome {
  margin-top: 6px;
  font-weight: 600;
  line-height: 1.25;
  word-break: break-word;
}

.submenu-perfil-email {
  margin-top: 2px;
  word-break: break-word;
}
</style>
